export class ValueEnabledModel {
  public enabled: boolean;
  public value: string;
  constructor(valueEnabled?: {enabled?: boolean | null; value?: string | null}) {
    this.enabled = !!valueEnabled?.enabled;
    this.value = valueEnabled?.value ?? '';
  }
}
